import { z } from "zod";

import { PositiveIntegerSchema } from "./primitives.js";

export const RESOURCE_TYPES = ["food", "production", "trade", "science", "culture"] as const;

export const ResourceTypeSchema = z.enum(RESOURCE_TYPES);

/**
 * Missing keys mean zero. Present keys must be positive, so `{}` is the only
 * representation of a zero cost/production bundle and data never carries
 * meaningless explicit zeroes.
 */
export const ResourceBundleSchema = z
  .object({
    food: PositiveIntegerSchema.optional(),
    production: PositiveIntegerSchema.optional(),
    trade: PositiveIntegerSchema.optional(),
    science: PositiveIntegerSchema.optional(),
    culture: PositiveIntegerSchema.optional(),
  })
  .strict();

export const ResourceCostSchema = ResourceBundleSchema;
export const ResourceProductionSchema = ResourceBundleSchema;
export const ArmyUpkeepSchema = ResourceBundleSchema;

export type ArmyUpkeep = z.infer<typeof ArmyUpkeepSchema>;
export type ResourceBundle = z.infer<typeof ResourceBundleSchema>;
export type ResourceCost = z.infer<typeof ResourceCostSchema>;
export type ResourceProduction = z.infer<typeof ResourceProductionSchema>;
export type ResourceType = z.infer<typeof ResourceTypeSchema>;
